import { type ChartData } from './chartConfigUtils';
import CurrencyValueChart from './CurrencyValueChart';

interface DailyPaidContractsValueChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function DailyPaidContractsValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: DailyPaidContractsValueChartProps): JSX.Element {
    return (
        <CurrencyValueChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            currency={currency}
            config={{
                chartType: 'line',
                yAxisTitleKeyEur: 'statistics.charts.paidContractsValueEur',
                yAxisTitleKeyLei: 'statistics.charts.paidContractsValueLei',
                yAxisTitleFallbackEur: 'Paid Contracts Value (EUR)',
                yAxisTitleFallbackLei: 'Paid Contracts Value (Lei)',
                color: '#52c41a',
                seriesNameKey: 'statistics.charts.paidContractsValue',
                seriesNameFallback: 'Paid Contracts Value',
            }}
        />
    );
}

export default DailyPaidContractsValueChart;
